"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seaport__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "conduitController",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "BadContractSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "BadFraction",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "BadReturnValueFromERC20OnTransfer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
        ],
        name: "BadSignatureV",
        type: "error",
    },
    {
        inputs: [],
        name: "CannotCancelOrder",
        type: "error",
    },
    {
        inputs: [],
        name: "ConsiderationCriteriaResolverOutOfRange",
        type: "error",
    },
    {
        inputs: [],
        name: "ConsiderationLengthNotEqualToTotalOriginal",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "orderIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "considerationIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "shortfallAmount",
                type: "uint256",
            },
        ],
        name: "ConsiderationNotMet",
        type: "error",
    },
    {
        inputs: [],
        name: "CriteriaNotEnabledForItem",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "identifiers",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "ERC1155BatchTransferGenericFailure",
        type: "error",
    },
    {
        inputs: [],
        name: "InexactFraction",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientNativeTokensSupplied",
        type: "error",
    },
    {
        inputs: [],
        name: "Invalid1155BatchTransferEncoding",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBasicOrderParameterEncoding",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "InvalidCallToConduit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "conduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "conduit",
                type: "address",
            },
        ],
        name: "InvalidConduit",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "InvalidContractOrder",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "InvalidERC721TransferAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidFulfillmentComponentData",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "InvalidMsgValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidNativeOfferItem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidProof",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "InvalidRestrictedOrder",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSigner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "InvalidTime",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "fulfillmentIndex",
                type: "uint256",
            },
        ],
        name: "MismatchedFulfillmentOfferAndConsiderationComponents",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "enum Side",
                name: "side",
                type: "uint8",
            },
        ],
        name: "MissingFulfillmentComponentOnAggregation",
        type: "error",
    },
    {
        inputs: [],
        name: "MissingItemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "MissingOriginalConsiderationItems",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "NativeTokenTransferGenericFailure",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "NoContract",
        type: "error",
    },
    {
        inputs: [],
        name: "NoReentrantCalls",
        type: "error",
    },
    {
        inputs: [],
        name: "NoSpecifiedOrdersAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "OfferAndConsiderationRequiredOnFulfillment",
        type: "error",
    },
    {
        inputs: [],
        name: "OfferCriteriaResolverOutOfRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "OrderAlreadyFilled",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "enum Side",
                name: "side",
                type: "uint8",
            },
        ],
        name: "OrderCriteriaResolverOutOfRange",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "OrderIsCancelled",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "OrderPartiallyFilled",
        type: "error",
    },
    {
        inputs: [],
        name: "PartialFillsNotEnabledForOrder",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "identifier",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "TokenTransferGenericFailure",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "orderIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "considerationIndex",
                type: "uint256",
            },
        ],
        name: "UnresolvedConsiderationCriteria",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "orderIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "offerIndex",
                type: "uint256",
            },
        ],
        name: "UnresolvedOfferCriteria",
        type: "error",
    },
    {
        inputs: [],
        name: "UnusedItemParameters",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newCounter",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "offerer",
                type: "address",
            },
        ],
        name: "CounterIncremented",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "offerer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "zone",
                type: "address",
            },
        ],
        name: "OrderCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "offerer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "zone",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "enum ItemType",
                        name: "itemType",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct SpentItem[]",
                name: "offer",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "enum ItemType",
                        name: "itemType",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "address payable",
                        name: "recipient",
                        type: "address",
                    },
                ],
                indexed: false,
                internalType: "struct ReceivedItem[]",
                name: "consideration",
                type: "tuple[]",
            },
        ],
        name: "OrderFulfilled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OfferItem[]",
                        name: "offer",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ConsiderationItem[]",
                        name: "consideration",
                        type: "tuple[]",
                    },
                    {
                        internalType: "enum OrderType",
                        name: "orderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "totalOriginalConsiderationItems",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct OrderParameters",
                name: "orderParameters",
                type: "tuple",
            },
        ],
        name: "OrderValidated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32[]",
                name: "orderHashes",
                type: "bytes32[]",
            },
        ],
        name: "OrdersMatched",
        type: "event",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OfferItem[]",
                        name: "offer",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ConsiderationItem[]",
                        name: "consideration",
                        type: "tuple[]",
                    },
                    {
                        internalType: "enum OrderType",
                        name: "orderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "counter",
                        type: "uint256",
                    },
                ],
                internalType: "struct OrderComponents[]",
                name: "orders",
                type: "tuple[]",
            },
        ],
        name: "cancel",
        outputs: [
            {
                internalType: "bool",
                name: "cancelled",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "uint120",
                        name: "numerator",
                        type: "uint120",
                    },
                    {
                        internalType: "uint120",
                        name: "denominator",
                        type: "uint120",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "extraData",
                        type: "bytes",
                    },
                ],
                internalType: "struct AdvancedOrder",
                name: "",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "enum Side",
                        name: "side",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "criteriaProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct CriteriaResolver[]",
                name: "",
                type: "tuple[]",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "fulfillAdvancedOrder",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "uint120",
                        name: "numerator",
                        type: "uint120",
                    },
                    {
                        internalType: "uint120",
                        name: "denominator",
                        type: "uint120",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "extraData",
                        type: "bytes",
                    },
                ],
                internalType: "struct AdvancedOrder[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "enum Side",
                        name: "side",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "criteriaProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct CriteriaResolver[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maximumFulfilled",
                type: "uint256",
            },
        ],
        name: "fulfillAvailableAdvancedOrders",
        outputs: [
            {
                internalType: "bool[]",
                name: "",
                type: "bool[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "itemIndex",
                        type: "uint256",
                    },
                ],
                internalType: "struct FulfillmentComponent[][]",
                name: "",
                type: "tuple[][]",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "maximumFulfilled",
                type: "uint256",
            },
        ],
        name: "fulfillAvailableOrders",
        outputs: [
            {
                internalType: "bool[]",
                name: "",
                type: "bool[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "considerationToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "address payable",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "offerToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "offerIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "offerAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "enum BasicOrderType",
                        name: "basicOrderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "offererConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "fulfillerConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "totalOriginalAdditionalRecipients",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct AdditionalRecipient[]",
                        name: "additionalRecipients",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct BasicOrderParameters",
                name: "parameters",
                type: "tuple",
            },
        ],
        name: "fulfillBasicOrder",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "considerationToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "considerationAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "address payable",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "offerToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "offerIdentifier",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "offerAmount",
                        type: "uint256",
                    },
                    {
                        internalType: "enum BasicOrderType",
                        name: "basicOrderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "offererConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "fulfillerConduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "totalOriginalAdditionalRecipients",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct AdditionalRecipient[]",
                        name: "additionalRecipients",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct BasicOrderParameters",
                name: "parameters",
                type: "tuple",
            },
        ],
        name: "fulfillBasicOrder_efficient_6GL6yc",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order",
                name: "",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "fulfillerConduitKey",
                type: "bytes32",
            },
        ],
        name: "fulfillOrder",
        outputs: [
            {
                internalType: "bool",
                name: "fulfilled",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractOfferer",
                type: "address",
            },
        ],
        name: "getContractOffererNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "offerer",
                type: "address",
            },
        ],
        name: "getCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "counter",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "zone",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OfferItem[]",
                        name: "offer",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifierOrCriteria",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "startAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endAmount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ConsiderationItem[]",
                        name: "consideration",
                        type: "tuple[]",
                    },
                    {
                        internalType: "enum OrderType",
                        name: "orderType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "startTime",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endTime",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "zoneHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "salt",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "counter",
                        type: "uint256",
                    },
                ],
                internalType: "struct OrderComponents",
                name: "",
                type: "tuple",
            },
        ],
        name: "getOrderHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "orderHash",
                type: "bytes32",
            },
        ],
        name: "getOrderStatus",
        outputs: [
            {
                internalType: "bool",
                name: "isValidated",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "isCancelled",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "totalFilled",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalSize",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "incrementCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "newCounter",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "information",
        outputs: [
            {
                internalType: "string",
                name: "version",
                type: "string",
            },
            {
                internalType: "bytes32",
                name: "domainSeparator",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "conduitController",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "uint120",
                        name: "numerator",
                        type: "uint120",
                    },
                    {
                        internalType: "uint120",
                        name: "denominator",
                        type: "uint120",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "extraData",
                        type: "bytes",
                    },
                ],
                internalType: "struct AdvancedOrder[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "orderIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "enum Side",
                        name: "side",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "identifier",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "criteriaProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct CriteriaResolver[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "offerComponents",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "considerationComponents",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Fulfillment[]",
                name: "",
                type: "tuple[]",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
        ],
        name: "matchAdvancedOrders",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order[]",
                name: "",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "offerComponents",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "orderIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "itemIndex",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FulfillmentComponent[]",
                        name: "considerationComponents",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Fulfillment[]",
                name: "",
                type: "tuple[]",
            },
        ],
        name: "matchOrders",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "enum ItemType",
                                name: "itemType",
                                type: "uint8",
                            },
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "identifier",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                            {
                                internalType: "address payable",
                                name: "recipient",
                                type: "address",
                            },
                        ],
                        internalType: "struct ReceivedItem",
                        name: "item",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "offerer",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "conduitKey",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Execution[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "offerer",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "zone",
                                type: "address",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                ],
                                internalType: "struct OfferItem[]",
                                name: "offer",
                                type: "tuple[]",
                            },
                            {
                                components: [
                                    {
                                        internalType: "enum ItemType",
                                        name: "itemType",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "address",
                                        name: "token",
                                        type: "address",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "identifierOrCriteria",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "startAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "uint256",
                                        name: "endAmount",
                                        type: "uint256",
                                    },
                                    {
                                        internalType: "address payable",
                                        name: "recipient",
                                        type: "address",
                                    },
                                ],
                                internalType: "struct ConsiderationItem[]",
                                name: "consideration",
                                type: "tuple[]",
                            },
                            {
                                internalType: "enum OrderType",
                                name: "orderType",
                                type: "uint8",
                            },
                            {
                                internalType: "uint256",
                                name: "startTime",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "endTime",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "zoneHash",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "salt",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "conduitKey",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "totalOriginalConsiderationItems",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct OrderParameters",
                        name: "parameters",
                        type: "tuple",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct Order[]",
                name: "",
                type: "tuple[]",
            },
        ],
        name: "validate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Seaport__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(conduitController, overrides) {
        return super.getDeployTransaction(conduitController, overrides || {});
    }
    deploy(conduitController, overrides) {
        return super.deploy(conduitController, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Seaport__factory = Seaport__factory;
Seaport__factory.bytecode = _bytecode;
Seaport__factory.abi = _abi;
//# sourceMappingURL=Seaport__factory.js.map